import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import CourtsNew from "./components/CourtsNew";
import SignIn from "./components/SignIn";
import AddNewCourt from "./components/AddNewCourt";
import CourtDetailNew from "./components/CourtDetailNew";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookieBanner from "./components/CookieBanner";
import CookieSettings from "./components/CookieSettings";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminDashboardApprove from "./components/admin/AdminDashboardApprove"
import AdminLogin from "./components/admin/AdminLogin";
import PrivateRoute from "./components/admin/PrivateRoute";
import BlogHome from "./components/blog/BlogHome";
import BlogRouter from "./components/blog/BlogRouter";

function App() {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    // Load Google Analytics script dynamically
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-R1EZY7CZVH`;
    document.head.appendChild(script);

    // Initialize Google Analytics
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-R1EZY7CZVH");

    // Handle screen resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
      if (window.innerWidth >= 600) {
        setMenuOpen(false); // Close menu when resizing back to large screen
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Router>
      <div className="App">
        <CookieBanner onSettingsOpen={() => setSettingsOpen(true)} />
        <CookieSettings
          isOpen={settingsOpen}
          onClose={() => setSettingsOpen(false)}
        />
        <header className="App-header">
          <nav className="App-header">
            <Link to="/" className="logo-container">
              <img
                src={require("./assets/tfd1.png")}
                alt="Site Logo"
                className="site-logo"
              />
            </Link>

            {/* Hamburger Menu */}
            {isMobile ? (
              <button
                className="menu-button"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                ☰
              </button>
            ) : (
              <ul className="App-nav">
                <li>
                  <Link to="/">HOME</Link>
                </li>
                <li>
                  <Link to="/courts">COURTS</Link>
                </li>
                <li>
                  <Link to="/about">ABOUT</Link>
                </li>
                {/* <li>
                  <Link to="/contact">CONTACT</Link>
                </li> */}
                <li>
                  <Link to="/blog">BLOG</Link>
                </li>
                {/* <li>
                  <Link to="/signin">LOGIN / SIGN UP</Link>
                </li> */}
              </ul>
            )}
          </nav>

          {/* Dropdown Menu for Mobile */}
          {menuOpen && (
            <ul className="mobile-menu">
              <li>
                <Link to="/" onClick={() => setMenuOpen(false)}>
                  HOME
                </Link>
              </li>
              <li>
                <Link to="/courts" onClick={() => setMenuOpen(false)}>
                  COURTS
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={() => setMenuOpen(false)}>
                  ABOUT
                </Link>
              </li>
              {/* <li>
                <Link to="/contact" onClick={() => setMenuOpen(false)}>
                  CONTACT
                </Link>
              </li> */}
              <li>
                <Link to="/blog" onClick={() => setMenuOpen(false)}>
                  BLOG
                </Link>
              </li>
              {/* <li>
                <Link to="/signin" onClick={() => setMenuOpen(false)}>
                  LOGIN / SIGN UP
                </Link>
              </li> */}
            </ul>
          )}
        </header>

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/courts" element={<CourtsNew />} />
            <Route path="/courts/:country" element={<CourtsNew />} />
            <Route path="/courts/:country/:state" element={<CourtsNew />} />
            <Route
              path="/courts/:country/:state/:name"
              element={<CourtDetailNew />}
            />
            <Route path="/courts/:country/:state/:city" element={<Courts />} /> */}

            <Route path="/courts" element={<CourtsNew />} />
            <Route path="/courts/:country" element={<CourtsNew />} />
            <Route path="/courts/:country/:state" element={<CourtsNew />} />
            <Route path="/courts/:country/:state/:city" element={<CourtsNew />} />
            <Route path="/courts/:country/:state/:city/:slug" element={<CourtDetailNew />} />

            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/courts/add" element={<AddNewCourt />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-settings" element={<CookieSettings />} />
            <Route path="/blog" element={<BlogHome />} />
            <Route path="/blog/:slug" element={<BlogRouter />} />

            {/* Admin routes */}
            <Route
              path="/admin/login"
              element={<AdminLogin setAuthenticated={setAuthenticated} />}
            />
            <Route
              path="/admin/dashboard"
              element={
                <PrivateRoute authenticated={authenticated}>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/approve"
              element={
                <PrivateRoute authenticated={authenticated}>
                  <AdminDashboardApprove />
                </PrivateRoute>
              }
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
